import * as React from 'react';

export function Cols(props: React.HTMLProps<HTMLDivElement>): React.ReactNode {
	const divProps = {
		...props,
		className: (props.className || '') + ' cols p-xxs',
	};
	return <div {...divProps} />;
}

type ColProps = { width?: string } & React.HTMLProps<HTMLDivElement>;

type NoStyle = Record<string, never>;
type FlexStyle = { flexGrow: number, flexBasis: number } & React.CSSProperties;
type FixedStyle = { width: string | number } & React.CSSProperties;
type ColStyle = FlexStyle | FixedStyle | NoStyle;

function widthIsStar(width: string): boolean {
	return /\d*\*{1}/.test(width);
}

function widthIsNumber(width: string): boolean {
	return /^[\d]*$/.test(width);
}

function getStyle(width?: string): ColStyle {
	if (width === undefined)
		return {};

	if (width === '*' || widthIsStar(width)) {
		return {
			flexGrow: width === '*' ? 1 : parseFloat(width.slice(0, -1)),
			flexBasis: 0,
			overflowX: 'hidden',
			whiteSpace: 'nowrap',

		};
	}

	if (widthIsNumber(width)) {
		return {
			width: parseFloat(width)
		};
	}

	return {
		width
	};
}

export function Col(props: ColProps): React.ReactNode {

	const { width, ...rest } = props;

	const newProps = {
		...rest,
		style: {
			...props.style,
			...getStyle(props.width)
		}
	};
	return <div {...newProps} />;
}
